<div
  *ngIf="isAlertVisible"
  class="mx-auto mt-6 max-w-prose rounded-xl bg-warning py-6 px-4 text-center text-sm text-apricot-1"
>
  <button
    type="button"
    (click)="click()"
    class="font-medium text-duck-blue-2 hover:text-duck-blue-1"
  >
    Välj utövare
  </button>
  om du vill se tillgängliga datum.
</div>
